import React, { useContext, useMemo } from "react";
import { Button } from "react-bootstrap";
import { SXModalBase } from "../Modales/SXModal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
interface disclaimerModalProps {
  isModalOpen: boolean;
  close: () => void;
  onDoNotShowAgainChange: (showDisclaimer: boolean) => void;
}

export const DisclaimerModal = (props: disclaimerModalProps) => {
  const { t, i18n } = useTranslation();

  const footer = (
    <>
      <Button
        className="modal-btn"
        onClick={() => {
          props.onDoNotShowAgainChange(false);
        }}
      >
        {t("dont_show_again_.label")}
      </Button>
      <Button
        id="disclaimerok"
        className="modal-btn"
        onClick={() => {
          props.close();
        }}
      >
        {t("button_ok_.label")}
      </Button>
    </>
  );

  const body = <i>{t("disclaimer_body_.label")}</i>;
  return (
    <>
      <SXModalBase header={t("disclaimer_.label")} show={props.isModalOpen} size="lg" body={body} footer={footer} />
    </>
  );
};
